<template>
	<div>
		
		<div class="r-title">
			<img src="../../assets/imgs/news/news-title-bg.png" class="r-title-bg">
			<span style="z-index: 1;position: relative;">My Demands</span>
		</div>
		
		<div style="display: flex;" class="box1">
			<div class="btn-normal" :class="{ 'btn-normal-active': activebtn == 1 }" @click="changebtn(1)">Under Review</div>
			<div class="btn-normal" :class="{ 'btn-normal-active': activebtn == 2 }" @click="changebtn(2)">Progressing</div>
			<div class="btn-normal" :class="{ 'btn-normal-active': activebtn == 5 }" @click="changebtn(5)">Failed</div>
			<div class="btn-normal" :class="{ 'btn-normal-active': activebtn == 3 }" @click="changebtn(3)">Expired</div>
			<div class="btn-normal" :class="{ 'btn-normal-active': activebtn == 4 }" @click="changebtn(4)">Closed</div>
		</div>
		<div>
			
			<!-- 我发布的需求 -->
			<div style="display: flex;flex-direction: column;margin-top: 1rem;">
				
				<div class="hover-up transition-normal fadeIn animated supplier-box" style="background-color: #fff;padding: 2rem;display: flex;margin-bottom: 2rem;border-radius: 1rem;"
						v-for="(item, index2) in demanddata" :key="index2">
					<div style="display: flex;flex-direction: column;width: 100%;position: relative;">
						<div style="display: flex;align-items: center;margin-bottom: 1rem;">
							<div :style="{backgroundImage: 'url('+item.user.avatar+')'}" style="" class="main-img"></div>
							<div style="" class="main-title" v-text="item.user.username"></div>
						</div>
						<!-- <div style="display: flex;flex-wrap: wrap;cursor: pointer;" @click="tosupplierdetail(item)">
							<div v-for="(c, index3) in item.certifications" :key="index3" style="padding:0rem 0.5rem;border: 1px solid #D8D8D8;border-radius: 2rem;font-size: 0.5rem;
							display: flex;align-items: center;justify-content: center;margin-right: 0.5rem;margin-bottom: 0.5rem;" v-text="c.name"></div>
						</div> -->
						<!-- <div style="display: flex;justify-content: flex-end;margin-top: 1rem;" v-if="!isMobile">
							<div style="color: #333;font-size: 0.8rem;display: flex;align-items: center;justify-content: center;border-radius: 3rem;padding: 0.4rem 0.7rem;
									font-weight: bold;width: 6rem;cursor: pointer;position: absolute;right: 0;bottom: 0;"
									:class="{'btn-cyan':!item.follow, 'btn-lightgreen':item.follow}" @click="changefollow(item)" v-text="item.follow?'UnFollow':'Follow'"></div>
						</div> -->
						
						<div @click="todemanddetail(item)" style="cursor: pointer;">
							
							<div style="font-size: 1rem;color: #000;margin-bottom: 1rem;" class="supplier-desc" v-text="item.content"></div>
							<div style="font-size: 0.8rem;color: #666;margin-bottom: 1rem;">
								# {{item.classify.title}}
							</div>
							
							<div style="display: flex;justify-content: space-between;align-items: center;">
								<div>
									Deadline: {{item.expireTime | formatDate}}
								</div>
								<div class="btn-cyan-liner" style="padding: 0.4rem 1rem;border-radius: 5rem;cursor: pointer;font-size: 0.8rem;font-weight: 500;">
									more
								</div>
							</div>
						</div>
						
						<div style="display: flex;margin-top: 1rem;" v-if="activebtn!=1">
							<!-- 编辑 -->
							<div style="width: fit-content;font-size: 0.9rem;" class="btn-normal" @click="publishboxshow(item)">
								Revise
							</div>
							<!-- 开关 -->
							<div style="position: relative;">
								<div style="width: fit-content;font-size: 0.9rem;margin-left: 0rem;margin-right: 0;" class="btn-normal" @click="changestate(item)">
									{{item.state?'close needs':'open needs'}}
								</div>
							</div>
						</div>
						
					</div>
				</div>
				
				<!-- 空状态 -->
				<div v-show="demanddata.length==0&&!loading" class="nodata-box">
					<img src="../../assets/imgs/nodata.svg" class="nodata-img">
				</div>
			</div>
		</div>
		
		<!-- 发布需求组件 -->
		<Demandpulish></Demandpulish>
	</div>
</template>

<script>
		import Demandpulish from '/src/components/demand/demandpulish.vue'
		export default {
			data() {
				return {
					type:0,
					isMobile: false,
					loading:true,
					
					activebtn:1,
					demanddata:[]
				}
			},
			components: {
				Demandpulish
			},
			filters:{
				formatDate:function(timestemp){
					let date = new Date(timestemp*1000)
					return date.getFullYear() + '/' + (date.getMonth()+1) +'/'+ date.getDate() 
				}
			},
			methods: {
				changebtn(type){
					this.activebtn = type
					this.getdemanddata()
				},
				getdemanddata(){
					let url
					if(this.activebtn == 1){
						url = '?status=1'
					}else if(this.activebtn == 2){
						url = '?status=2'
					}else if(this.activebtn == 3){
						url = '?status=3'
					}else if(this.activebtn == 4){
						url = '?state=false'
					}else if(this.activebtn == 5){
						url = '?status=4'
					}
					this.request({
						method: 'get',
						url: '/gci/demand/mine'+url,
					}).then(res => {
						this.demanddata = res.data.items
						this.loading = false
					}).catch(error => {
						console.error(error.response)
					})
				},
				todemanddetail(item){
					this.$router.push({name:'demanddetail',query:{id:item.id}})
				},
				
				changestate(item){
					let params = {
						state: !item.state
					}
					this.request({
						method: 'post',
						url: '/gci/demand/'+item.id+'/edit',
						data:params
					}).then(res => {
						if(res.status==0){
							this.$bus.$emit('message',{
								type:2,
								msg: 'update success'
							})
							this.getdemanddata()
							// this.data.state = bool
						}else{
							this.$bus.$emit('message',{
								type:3,
								msg: res.msg
							})
						}
					}).catch(error => {
						console.error(error.response)
					})
				},
				publishboxshow(item, type){
					let query = {
						type:2,
						show:true,
						data: item
					}
					console.info(query)
					this.$bus.$emit('publishbox', query)
				},
			},
			mounted() {
				localStorage.getItem('isMobile')=='null'?this.isMobile = false:this.isMobile = true
				this.getdemanddata()
			}
		}
</script>

<style lang="scss" scoped>
	.r-title{
		height: 3rem;
		font-size: 1.5rem;
		font-weight: bold;
		position: relative;
		.r-title-bg{
			width: 13rem;position: absolute;left: -0.5rem;top: -2rem
		}
	}
	.main-img{
		min-width: 2.5rem;height: 2.5rem;background-position: center center;background-size: cover;background-repeat: no-repeat;border-radius: 50%;margin-right: 1rem;
	}
	.main-title{
		color: #000;font-size: 1.2rem;font-weight: bold;margin-bottom: 0.5rem;
	}
	.supplier-desc{
		display: -webkit-box;
		-webkit-line-clamp: 3;
		-webkit-box-orient: vertical;
		text-overflow: ellipsis;
		overflow: hidden;
	}
	@media (max-width:767px) {
		
		.main-img{
			margin-bottom: 1rem;margin-right: 1rem;
		}
		.main-title{
			font-size: 1.2rem;
		}
		.box1{
			overflow: scroll;
		}
		.box1::-webkit-scrollbar{
			display: none;
		}
		.btn-normal{
			min-width: fit-content;
		}
	}
</style>